<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2521"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2525"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2535"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2533" /></clipPath></defs><g
     id="g2527"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2529"><g
         id="g2531"
         clip-path="url(#clipPath2535)"><g
           id="g2537"
           transform="translate(170,429)"><path
             d="m 0,0 -53.787,54.144 c -11.716,11.808 -30.71,11.808 -42.426,0 L -150,1"
             style="stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2539" /></g><g
           id="g2541"
           transform="translate(492,430)"><path
             d="m 0,0 -52.787,53.144 c -11.716,11.808 -30.71,11.808 -42.426,0 L -148,1"
             style="stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2543" /></g><g
           id="g2545"
           transform="translate(256,20)"><path
             d="m 0,0 v 85.231 c -0.124,34.801 -14.588,67.849 -40.884,90.643 l -78.536,68.081 C -145.829,266.849 -161,300.078 -161,335.028 V 458"
             style="stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2547" /></g><g
           id="g2549"
           transform="translate(308,204.6436)"><path
             d="M 0,0 68.42,59.312 C 94.829,82.205 110,115.435 110,150.385 v 122.971"
             style="stroke:#000000;stroke-width:40;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2551" /></g></g></g></g></svg>
</template>
